module.exports = __webpack_public_path__ + "static/pro-spec-diagram-e879442f584a75fb83f9eaf1e7cbe712.png";